<section class="inbox" [class.inbox--compact]="compact" aria-label="Centro de notificaciones" [attr.aria-busy]="loading">
    <header class="inbox__header">
        <div class="inbox__heading">
            <span class="inbox__symbol"><i class="pi pi-bell" aria-hidden="true"></i></span>
            <div>
                <h1>{{ compact ? 'Notificaciones' : 'Centro de notificaciones' }}</h1>
                <p>{{ compact ? 'Tus últimas novedades' : 'Todas tus novedades y avisos, en un solo lugar.' }}</p>
            </div>
        </div>
        @if (data && data.unread > 0) {
            <span class="inbox__count">{{ data.unread }} sin leer</span>
        }
    </header>

    <div class="inbox__toolbar">
        <div class="inbox__filters" role="group" aria-label="Filtrar por estado de lectura">
            @for (item of filters; track item.value) {
                <button type="button" [class.is-active]="filter === item.value"
                    [attr.aria-pressed]="filter === item.value" (click)="setFilter(item.value)">
                    {{ item.label }}
                </button>
            }
        </div>
        <button type="button" class="inbox__read-all" (click)="markAllRead()"
            [disabled]="loading || !data?.unread || markingAll || pending.size > 0"
            [attr.title]="compact ? 'Marcar todas como leídas' : null"
            aria-label="Marcar todas las notificaciones como leídas">
            <i [class]="markingAll ? 'pi pi-spin pi-spinner' : 'pi pi-check-circle'" aria-hidden="true"></i>
            <span>{{ compact ? 'Leer todas' : 'Marcar todas como leídas' }}</span>
        </button>
    </div>

    @if (actionError) {
        <div class="inbox__error" role="alert">{{ actionError }}</div>
    }
    <div class="inbox__body" aria-live="polite">
        @if (loading) {
            <div class="inbox__state" role="status">
                <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                <p>Cargando notificaciones...</p>
            </div>
        } @else if (error) {
            <div class="inbox__state inbox__state--error" role="alert">
                <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
                <p>{{ error }}</p>
                <button type="button" class="inbox__retry" (click)="refresh()">Reintentar</button>
            </div>
        } @else if (!data?.items?.length) {
            <div class="inbox__state">
                <span class="inbox__empty-icon"><i class="pi pi-inbox" aria-hidden="true"></i></span>
                <h2>{{ filter === 'unread' ? 'Estás al día' : 'Sin notificaciones' }}</h2>
                <p>{{ filter === 'unread' ? 'No tenés notificaciones pendientes de lectura.' : 'No hay notificaciones para este filtro.' }}</p>
            </div>
        } @else {
            <ul class="inbox__list">
                @for (notification of data!.items; track notification.id) {
                    <li class="inbox__item" [class.is-unread]="!notification.visto">
                        <span class="inbox__item-icon"><i [class]="icon(notification.tipo)" aria-hidden="true"></i></span>
                        <div class="inbox__content">
                            <div class="inbox__meta">
                                <span class="inbox__type">{{ notification.tipo }}</span>
                                <span class="inbox__status">{{ notification.visto ? 'Leída' : 'No leída' }}</span>
                            </div>
                            <h2>{{ notification.titulo }}</h2>
                            <p>{{ notification.texto }}</p>
                            <time [attr.datetime]="notification.fecha_hora">{{ notification.fecha_hora | date:'dd/MM/yyyy · HH:mm' }}</time>
                        </div>
                        <button type="button" class="inbox__toggle" (click)="toggleRead(notification)"
                            [disabled]="pending.has(notification.id) || markingAll"
                            [attr.aria-label]="notification.visto ? 'Marcar como no leída: ' + notification.titulo : 'Marcar como leída: ' + notification.titulo"
                            [attr.title]="notification.visto ? 'Marcar como no leída' : 'Marcar como leída'">
                            <i [class]="pending.has(notification.id) ? 'pi pi-spin pi-spinner' : notification.visto ? 'pi pi-envelope' : 'pi pi-check'" aria-hidden="true"></i>
                        </button>
                    </li>
                }
            </ul>
        }
    </div>

    @if (compact) {
        <footer class="inbox__footer">
            <button type="button" (click)="viewAll.emit()">
                Ver todas las notificaciones <i class="pi pi-arrow-right" aria-hidden="true"></i>
            </button>
        </footer>
    } @else if (data && data.total > 0 && !loading && !error) {
        <footer class="inbox__pagination">
            <span>Mostrando {{ first + 1 }}–{{ last }} de {{ data.total }}</span>
            <p-paginator [first]="first" [rows]="data.limit" [totalRecords]="data.total"
                [rowsPerPageOptions]="[10, 20, 50]" [pageLinkSize]="3"
                (onPageChange)="changePage($event)" />
        </footer>
    }
</section>
